export default __webpack_public_path__ + "static/media/SWT0990.34I-27954_-16767_0.6e52485a.jpg";